import { render, staticRenderFns } from "./bloquear_desbloquearPauta.vue?vue&type=template&id=ea55902c&"
import script from "./bloquear_desbloquearPauta.vue?vue&type=script&lang=js&"
export * from "./bloquear_desbloquearPauta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports